<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 lg12>
        <div class="headline green--text text--darken-4 font-weight-medium">
          Dispatch Details
        </div>
        <div class="caption">
          <br />
          <v-layout row wrap>
            <v-flex sm2
              ><v-icon size="16px">fa fa-info</v-icon> &nbsp; Information about
              item</v-flex
            >
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 sm12 lg12>
        <v-layout row wrap>
          <div class="filterStyle">
            <v-text-field label="Patient Id:" v-model="searchModel.pid">
              <template slot="prepend">
                <v-icon class="filterIcon grey--text text--darken-1"
                  >fa fa-filter</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <div class="filterStyle">
            <v-dialog ref="dtMenu" v-model="dtMenu" full-width width="290px">
              <v-text-field
                slot="activator"
                name="dt"
                label="Dispatch Date:"
                v-model="searchModel.dt"
                readonly
                clearable
                append-icon="fa fa-calendar-alt"
              >
                <template slot="prepend">
                  <v-icon class="filterIcon grey--text text--darken-1"
                    >fa fa-filter</v-icon
                  >
                </template>
              </v-text-field>
              <v-date-picker
                v-model="searchModel.dt"
                scrollable
                @input="dtMenu = false"
              >
              </v-date-picker>
            </v-dialog>
          </div>
          <v-flex>
            <v-btn color="primary" :disabled="loading" @click="api_get">
              <v-icon class="iconText">fa fa-search</v-icon>
              Search
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap> </v-layout>
      </v-flex>
      <v-flex sm12 lg12>
        <v-card>
          <v-card-text class="pa-0">
            <dispatch-disp
              :items="dispatches"
              :loading="loading"
            ></dispatch-disp>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WebH from "../../api/web";
import DispatchDisp from "../../components/dispatch/DispatchDisp";
export default {
  components: {
    DispatchDisp
  },
  created() {
    this.viewAll = this.$store.getters["UserStore/permissions"].includes(
      "pata.v"
    );
  },
  data() {
    return {
      dispatches: [],
      loading: false,
      viewAll: false,
      searchModel: {
        pid: "",
        dt: ""
      },
      dtMenu: false
    };
  },
  methods: {
    async api_get() {
      this.loading = true;
      this.dispatches = [];
      let url = "/dispatches/search";
      if (this.viewAll) {
        url = "/dispatches/searcha";
      }
      if (!this.searchModel.dt) this.searchModel.dt = "";
      url += "?pid=" + this.searchModel.pid;
      url += "&dt=" + this.searchModel.dt;
      const res = await WebH.Get(url, "dispatches");
      this.loading = false;
      console.log(res);
      if (res.Success) this.dispatches = res.Data;
    }
  }
};
</script>

<style scoped>
.filterStyle {
  padding: 12px;
  flex: 0 0 21%;
}
</style>
